import {
    chakra,
    Flex
} from '@chakra-ui/react';

export const Container = chakra(Flex, {
    label: 'ThreeEssentialsWelcomePageContainer',
    baseStyle: {
        justifyContent: 'center',
        w: '100%',
        maxW: '1368px',
        backgroundColor: '#fff',
        flexFlow: 'wrap'
    }
});
